import {
  addDays,
  eachDay,
  getDate,
  isSameDay,
  isSameMonth,
  isSaturday,
  isSunday,
  setDate,
  startOfWeek,
} from 'date-fns'
import React from 'react'
import { Date, Day, Days, DaysPicker, SelectedDayBackground } from './styled'

function DayPicker({
  date,
  change,
  selectedDay,
}: IDayPickerProps & IDayPickerDispatch) {
  const firstDayOfMonth = startOfWeek(setDate(date, 0), {
    weekStartsOn: 1,
  })
  const lastDayOfMonth = addDays(firstDayOfMonth, 41)
  const allDays = eachDay(firstDayOfMonth, lastDayOfMonth)

  function onClick(day: number) {
    return function() {
      change(setDate(date, day))
    }
  }

  return (
    <DaysPicker>
      <Days>
        {allDays.map((day: Date, i: number) =>
          isSameMonth(date, day) ? (
            <Day
              selected={getDate(date) === getDate(day)}
              isSelected={isSameDay(selectedDay, day)}
              weekend={isSunday(day) || isSaturday(day)}
              key={i}
              onClick={onClick(getDate(day))}
            >
              {getDate(date) === getDate(day) && <SelectedDayBackground />}
              {isSameDay(selectedDay, day) && (
                <SelectedDayBackground style={{ opacity: 0.7 }} />
              )}
              <Date>{getDate(day)}</Date>
            </Day>
          ) : (
            <Day key={i} inactive={true}>
              {getDate(day)}
            </Day>
          ),
        )}
      </Days>
    </DaysPicker>
  )
}

export default DayPicker

export interface IDayPickerProps {
  date: Date
  selectedDay?: Date
}

export interface IDayPickerDispatch {
  change?: (date: Date) => void
}
